/**
 * NicLen.Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type NotificationState = 'Nothing' | 'NotifyDriverSend' | 'TourUpdatedSend' | 'NotificationSent';

export const NotificationState = {
    Nothing: 'Nothing' as NotificationState,
    NotifyDriverSend: 'NotifyDriverSend' as NotificationState,
    TourUpdatedSend: 'TourUpdatedSend' as NotificationState,
    NotificationSent: 'NotificationSent' as NotificationState
};

